import { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import SideNav from '../component/um/agenda/SideNav'
import CreateAgendaTab from '../component/um/agenda/CreateAgendaTab'
import { AgendaTabKey } from '../component/um/agenda/agendaTypes'
import { Box, Typography } from '@material-ui/core'
import useTranslate from '../i18n/useTranslate'

function useQueryTab(defaultTab: AgendaTabKey = 'agenda') {
    const [tab, setTab] = useState<AgendaTabKey>(() => {
        const url = new URL(window.location.href)
        return (url.searchParams.get('tab') || defaultTab) as AgendaTabKey
    })
    const update = (next: AgendaTabKey) => {
        setTab(next)
        const url = new URL(window.location.href)
        url.searchParams.set('tab', next)
        window.history.replaceState(null, '', url.toString())
    }
    return [tab, update] as const
}

const CreateAgenda = () => {
    const classes = useStyles()
    const t = useTranslate()
    const [open, setOpen] = useState(false)
    const [tab, setTab] = useQueryTab('agenda')

    return (
        <div className={classes.root}>
            <div className={classes.layout} style={{ border: 0 }}>
                <SideNav open={open} tab={tab} onToggle={() => setOpen((o) => !o)} onSelect={setTab} />
                <main className={classes.contentWrap}>
                    {tab === 'agenda' && <CreateAgendaTab />}
                    {tab === 'minutes' && (
                        <Box className={classes.emptyWrap}>
                            <Typography variant="body1">{t.get('UM.SETTING_AGENDA.CANNOT_CREATE_REPORT')}</Typography>
                        </Box>
                    )}
                </main>
            </div>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    root: { display: 'flex', maxWidth: 1320, margin: '24px auto', padding: theme.spacing(0, 2), width: '100%' },
    contentWrap: { flexGrow: 1 },
    layout: { display: 'grid', gridTemplateColumns: 'auto 1fr', width: '100%' },
    emptyWrap: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 250,
        borderRadius: 12,
        border: '1px solid rgba(0,0,0,0.08)',
    },
}))

export default CreateAgenda
